/**
 * MIME-type predicates for categorizing uploaded files.
 */

// Helper to check if file is a media type (image or video)
export function isMediaType(mimeType: string): boolean {
    return mimeType.startsWith('image/') || mimeType.startsWith('video/');
}

// Helper to check if file is an audio type
export function isAudioType(mimeType: string): boolean {
    return mimeType.startsWith('audio/');
}

// Helper to check if file is a video type
export function isVideoType(mimeType: string): boolean {
    return mimeType.startsWith('video/');
}
